export default __webpack_public_path__ + "static/media/zoomin.ace4d8a9.svg";